import React, { useState } from 'react';
import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

interface ButtonSectionProps {
  routeToModifyBackToBack: () => void;
  fileDBUrl: string;
  setShowOverlay: (_value: React.SetStateAction<boolean>) => void;
  backPage: () => void;
  isEditable?: boolean;
  isEditEnabled: boolean;
}

export const FOB2BButtonSection: React.FC<ButtonSectionProps> = ({
  fileDBUrl,
  routeToModifyBackToBack,
  setShowOverlay,
  backPage,
  isEditable = true,
  isEditEnabled = true,
}) => {
  const [isModifyButtonLoading, setIsModifyButtonLoading] = useState(false);

  const onModifyWithLoadingIndicator = async () => {
    setIsModifyButtonLoading(true);
    await routeToModifyBackToBack();
    setIsModifyButtonLoading(false);
  };

  return (
    <div className="flex flex-row gap-4">
      {isEditable && (
        <ButtonDesigned
          style="outline"
          className=" flex items-center"
          onButtonClick={() => {
            backPage();
          }}
        >
          <img className=" my-auto rotate-180" title="Right" src="/assets/icons/flat/chevron-right_purple.svg"></img>
          Back
        </ButtonDesigned>
      )}
      {isEditEnabled && (
        <ButtonDesigned
          style="outline"
          onButtonClick={onModifyWithLoadingIndicator}
          isFunctionLoading={isModifyButtonLoading}
          disableButton={isModifyButtonLoading}
        >
          <BorderColorOutlinedIcon className="text-blue-600" />
          Modify
        </ButtonDesigned>
      )}
      <ButtonDesigned
        disableButton={fileDBUrl.length === 0}
        style="outline"
        onButtonClick={() => {
          fileDBUrl && setShowOverlay(true);
        }}
      >
        <ArticleOutlinedIcon className="text-blue-600 " />
        View contract
      </ButtonDesigned>
    </div>
  );
};
